import type { ErrorResponse } from "@core/types/errorResponse";
import { stringMessagesFromApiErrorFieldValue } from "@core/utils/apiErrorFieldValue";
import { MESSAGE_LABEL_REQUIRED } from "@features/presentationLayout/constants/presentationLayoutConstants";

const LABEL_PATH = /^sections\.(\d+)\.(rows|columns)\.(\d+)\.label$/;

/**
 * Turns Laravel `sections.N.rows.M.label` keys into friendly modal lines.
 * Other field keys keep a humanized prefix; non-field detail falls through to the caller.
 */
export function formatLayoutApiErrorMessages(
  error: ErrorResponse,
  sectionTitles: Array<string | null | undefined> = []
): string[] {
  if (!error?.errors || Object.keys(error.errors).length === 0) {
    return error?.detail ? [error.detail] : [];
  }

  const lines = Object.entries(error.errors).flatMap(([field, value]) =>
    stringMessagesFromApiErrorFieldValue(value).map((msg) => {
      const match = LABEL_PATH.exec(field);
      if (match) {
        const sectionIndex = Number(match[1]);
        const kind = match[2] === "rows" ? "row" : "column";
        const index = Number(match[3]) + 1;
        const title = (sectionTitles[sectionIndex] ?? "").trim() || `Section ${sectionIndex + 1}`;
        const body = /required/i.test(msg) ? MESSAGE_LABEL_REQUIRED : msg;
        return `${title} — ${kind} ${index}: ${body}`;
      }
      return `${field}: ${msg}`;
    })
  );

  if (lines.length === 0 && error.detail?.trim()) {
    return [error.detail.trim()];
  }

  return lines;
}
